import React, { useState, useEffect } from "react";
import _ from "lodash";
import { isInvalidDate } from "../../utils";
import {
  nameTitles,
  auStates,
  CATEGORY_OPTIONS,
  EXPIRY_DATE_BY_MONTH,
  ROUTE_PATHS,
  GENDER_OPTIONS,
  CORE_PLUS_GENDER_OPTIONS,
} from "../../constants";
import Button from "../Shared/Button";
import { useSelector } from "react-redux";
import moment from "moment";
import { useLocation } from "react-router-dom";
import ClinicForPatientForm from "./ClinicForPatientForm";
import ReferrerForPatientForm from "./ReferrerForPatientForm";

const isDataFromPMS = process.env.REACT_APP_DATA_SOURCE === "pms-api";
const genderOptions = isDataFromPMS ? GENDER_OPTIONS : CORE_PLUS_GENDER_OPTIONS;

const PatientForm = ({
  patient = null,
  submit,
  clientGroups,
  practitioners,
  isLoading = false,
  actionName,
  originalCategory,
  originalLocation,
  originalReferral,
  originalClinic,
  originalReferrer,
}) => {
  const { pathname } = useLocation();

  const elementControl = {
    isRenderCategory: pathname !== ROUTE_PATHS.CREATE_CLIENT,
    isRenderReferralDate: pathname !== ROUTE_PATHS.CREATE_CLIENT,
    isRenderLocation: pathname !== ROUTE_PATHS.CREATE_CLIENT,
    isRenderClinic: pathname !== ROUTE_PATHS.CREATE_CLIENT,
    isRenderReferrer: pathname !== ROUTE_PATHS.CREATE_CLIENT,
    isDisableCategory: pathname === ROUTE_PATHS.ARCHIVED_WORKFLOW || pathname === ROUTE_PATHS.HISTORY_WORKFLOW,
    isDisableReferralDate: pathname === ROUTE_PATHS.ARCHIVED_WORKFLOW || pathname === ROUTE_PATHS.HISTORY_WORKFLOW,
  };
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");

  const [title, setTitle] = useState("");
  const [gender, setGender] = useState("");
  const [clientGroupId, setClientGroupId] = useState("");

  const [practitionerId, setPractitionerId] = useState("");
  const [email, setEmail] = useState("");
  const [URN, setURN] = useState("");

  const [addressResidential, setAddressResidential] = useState({
    country: "AUSTRALIA",
    streetAddress: "",
    suburb: "",
    postcode: "",
    state: "",
  });
  const [addressPostal, setAddressPostal] = useState({
    country: "AUSTRALIA",
    streetAddress: "",
    suburb: "",
    postcode: "",
    state: "",
  });
  const [postalSameAsResidential, setPostalSameAsResidential] = useState(false);
  const locations = useSelector((state) => state.app.locations.filter((l) => l.name !== "Anywhere Healthcare"));
  const [phoneNumberMobile, setPhoneNumberMobile] = useState("");
  const [phoneNumberHome, setPhoneNumberHome] = useState("");
  const [phoneNumberWork, setPhoneNumberWork] = useState("");
  const [phoneNumberFax, setPhoneNumberFax] = useState("");

  const [category, setCategory] = useState("");
  useEffect(() => setCategory(originalCategory), [originalCategory]);

  const [clinic, setClinic] = useState("");
  useEffect(() => setClinic(originalClinic), [originalClinic]);

  const [referrer, setReferrer] = useState("");
  useEffect(() => setReferrer(originalReferrer), [originalReferrer]);

  const [location, setLocation] = useState({});
  useEffect(() => setLocation(originalLocation), [originalLocation]);
  const onLocationChange = (event) =>
    setLocation(_.find(locations, (l) => l.locationId === event.target.value) ?? null);

  const [startDate, setStartDate] = useState("");
  const [expiredDate, setExpiredDate] = useState("");
  const [expiredDateByMonth, setExpiredDateByMonth] = useState("");
  useEffect(() => {
    originalReferral?.startDate === undefined
      ? setStartDate("")
      : setStartDate(moment(originalReferral?.startDate, "YYYY-MM-DDTHH:mm:ss Z").format("YYYY-MM-DD"));
    originalReferral?.endDate === undefined || originalReferral?.endDate === "1900-01-01T00:00:00"
      ? setExpiredDate("")
      : setExpiredDate(moment(originalReferral?.endDate, "YYYY-MM-DDTHH:mm:ss Z").format("YYYY-MM-DD"));

    if (originalReferral?.endDate === "1900-01-01T00:00:00") {
      setExpiredDateByMonth("0");
    } else {
      setExpiredDateByMonth("");
    }
  }, [originalReferral]);

  const handleExpiryDateByMonthChange = (event) => {
    setExpiredDate("");
    setExpiredDateByMonth(event.target.value);
  };

  const handleExpiryDateChange = (event) => {
    setExpiredDateByMonth("");
    setExpiredDate(event.target.value);
  };
  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
  };
  const handleClinicValueChange = () => {
    return (key) => (value) => {
      setClinic((prev) => ({
        ...prev,
        [key]: value,
      }));
    };
  };

  const updateClinicResource = () => {
    return (resource) => {
      setClinic(resource);
    };
  };

  const handleReferrerValueChange = () => {
    return (key) => (value) => {
      setReferrer((prev) => ({
        ...prev,
        [key]: value,
      }));
    };
  };

  const updateReferrerResource = () => {
    return (resource) => {
      setReferrer(resource);
    };
  };

  useEffect(() => {
    if (!_.isNull(patient)) {
      console.log("patient", _.get(patient, "ExternalId", ""), _.get(patient, "firstName", ""));
      setURN(_.get(patient, "ExternalId", ""));
      setFirstName(_.get(patient, "firstName", ""));
      setLastName(_.get(patient, "lastName", ""));
      setDateOfBirth(_.get(patient, "dateOfBirth", ""));
      setTitle(_.get(patient, "title", ""));
      setGender(_.get(patient, "gender", ""));
      setClientGroupId(_.get(patient, "clientGroupId", ""));
      setPractitionerId(_.get(patient, "practitionerId", ""));
      setEmail(_.get(patient, "email", ""));
      setPhoneNumberMobile(_.get(patient, "phoneNumberMobile", ""));
      setPhoneNumberHome(_.get(patient, "phoneNumberHome", ""));
      setPhoneNumberWork(_.get(patient, "phoneNumberWork", ""));
      setPhoneNumberFax(_.get(patient, "phoneNumberFax", ""));
      setPostalSameAsResidential(_.get(patient, "postalSameAsResidential", false));
      setAddressResidential({
        ..._.get(patient, "addressResidential", {
          country: "AUSTRALIA",
          streetAddress: "",
          state: "",
          suburb: "",
          postcode: "",
        }),
      });
      setAddressPostal({
        ..._.get(patient, "addressPostal", {
          country: "AUSTRALIA",
          streetAddress: "",
          state: "",
          suburb: "",
          postcode: "",
        }),
      });
    }
  }, [patient]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (isInvalidDate(dateOfBirth)) {
      return;
    }

    if (_.isEmpty(firstName)) {
      return;
    }

    if (_.isEmpty(lastName)) {
      return;
    }

    const client = {
      ExternalId: URN,
      firstName,
      lastName,
      dateOfBirth,
      title,
      gender,
      clientGroupId,
      practitionerId,
      email,
      addressResidential,
      addressPostal,
      postalSameAsResidential,
      phoneNumberMobile,
      phoneNumberHome,
      phoneNumberWork,
      phoneNumberFax,
    };
    const referralDate = {
      startDate,
      expiredDate,
      expiredDateByMonth,
    };
    submit({ client, category, hospital: location, referralDate, clinic, referrer });
  };

  return (
    <>
      <p className="menu-label">Client Details</p>
      <div className="columns is-mobile is-variable is-1">
        <div className="column is-one-third">
          <div className="control">
            <div className="select is-size-7 is-fullwidth">
              <select className="is-radiusless" onChange={(e) => setTitle(e.target.value)} value={title}>
                <option value="">Title</option>
                {nameTitles.map((title, idx) => (
                  <option key={idx} value={title.value}>
                    {title.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <div className="column is-one-third">
          <div className="control">
            <input
              className={`${_.isEmpty(firstName) ? "is-danger " : ""}input is-radiusless is-size-7`}
              type="text"
              placeholder="Firstname"
              onChange={(e) => setFirstName(e.target.value)}
              value={firstName}
            />
          </div>
        </div>
        <div className="column is-one-third">
          <div className="control">
            <input
              className={`${_.isEmpty(lastName) ? "is-danger " : ""}input is-radiusless is-size-7`}
              type="text"
              placeholder="Lastname"
              onChange={(e) => setLastName(e.target.value)}
              value={lastName}
            />
          </div>
        </div>
      </div>
      <div className="columns is-mobile is-variable is-1">
        <div className={`column ${isDataFromPMS ? "is-half" : "is-one-third"}`}>
          <div className="control">
            <input
              className={`${isInvalidDate(dateOfBirth) ? "is-danger " : ""}input is-radiusless is-size-7`}
              type="text"
              placeholder="DOB"
              onChange={(e) => setDateOfBirth(e.target.value)}
              value={dateOfBirth}
            />
          </div>
        </div>
        <div className={`column ${isDataFromPMS ? "is-half" : "is-one-third"}`}>
          <div className="control">
            <div className="select is-size-7 is-fullwidth">
              <select className="is-radiusless" onChange={(e) => setGender(e.target.value)} value={gender}>
                <option value="">Gender</option>
                {genderOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        {!isDataFromPMS && (
          <div className="column is-one-third">
            <div className="control">
              <div className="select is-size-7 is-fullwidth">
                <select
                  className="is-radiusless"
                  disabled={_.isEmpty(clientGroups)}
                  onChange={(e) => setClientGroupId(e.target.value)}
                  value={clientGroupId}
                >
                  <option value="">{_.isEmpty(clientGroups) ? "loading ..." : "Client Group"}</option>
                  {clientGroups &&
                    clientGroups.map((group, idx) => (
                      <option key={idx} value={group.clientGroupId}>
                        {group.clientGroupName}
                      </option>
                    ))}
                </select>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="columns is-mobile is-variable is-1">
        <div className="column is-half">
          <div className="control">
            <div className="select is-size-7 is-fullwidth">
              <select
                className="is-radiusless"
                disabled={_.isEmpty(practitioners)}
                onChange={(e) => setPractitionerId(e.target.value)}
                value={practitionerId}
              >
                <option value="">{_.isEmpty(practitioners) ? "loading ..." : "Case Manager"}</option>
                {practitioners &&
                  practitioners.map((pt, idx) => (
                    <option key={idx} value={pt.practitionerId}>{`${pt.firstName} ${pt.lastName}`}</option>
                  ))}
              </select>
            </div>
          </div>
        </div>
        <div className="column is-half">
          <div className="control">
            <input
              className="input is-size-7 is-radiusless is-fullwidth"
              type="text"
              placeholder="Email"
              onChange={(e) => setEmail(e.target.value)}
              value={email}
            />
          </div>
        </div>
      </div>
      <div className="columns is-mobile is-variable is-1">
        <div className="column">
          <div className="control">
            <input
              className="input is-size-7 is-radiusless is-fullwidth"
              type="text"
              placeholder="URN"
              onChange={(e) => setURN(e.target.value)}
              value={URN}
            />
          </div>
        </div>
      </div>
      <div className="columns is-mobile is-variable is-1">
        {elementControl.isRenderLocation && (
          <div className="column is-half">
            <div className="control">
              <div className="select is-size-7 is-fullwidth">
                <select className="is-radiusless" value={location?.locationId ?? ""} onChange={onLocationChange}>
                  <option value={""}>site</option>
                  {locations.map((location, idx) => (
                    <option key={idx} value={location.locationId}>
                      {location.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        )}
        {elementControl.isRenderCategory && (
          <div className="column is-half">
            <div className="control">
              <div className="select is-size-7 is-fullwidth">
                <select
                  className="is-radiusless"
                  value={category ?? ""}
                  disabled={elementControl.isDisableCategory}
                  onChange={(e) => setCategory(e.target.value)}
                >
                  <option value={""}>category</option>
                  {CATEGORY_OPTIONS.map((category) => {
                    return (
                      <option key={category.label} value={category.value}>
                        {category.label}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
          </div>
        )}
      </div>
      <p className="menu-label">Residential Address</p>
      <div className="columns is-mobile is-variable is-1">
        <div className="column is-two-thirds">
          <div className="control">
            <input
              className="input is-size-7 is-radiusless is-fullwidth"
              type="text"
              placeholder="Address"
              value={addressResidential.streetAddress}
              onChange={(e) =>
                setAddressResidential({
                  ...addressResidential,
                  streetAddress: e.target.value,
                })
              }
            />
          </div>
        </div>
        <div className="column is-one-third">
          <div className="control">
            <div className="select is-size-7 is-fullwidth">
              <select
                className="is-radiusless"
                value={addressResidential.state}
                onChange={(e) =>
                  setAddressResidential({
                    ...addressResidential,
                    state: e.target.value,
                  })
                }
              >
                <option value="">State</option>
                {auStates.map((state, idx) => (
                  <option key={idx} value={state.value}>
                    {state.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>
      <div className="columns is-mobile is-variable is-1">
        <div className="column is-half">
          <div className="control">
            <input
              className="input is-size-7 is-radiusless is-fullwidth"
              type="text"
              placeholder="Suburb"
              value={addressResidential.suburb}
              onChange={(e) =>
                setAddressResidential({
                  ...addressResidential,
                  suburb: e.target.value,
                })
              }
            />
          </div>
        </div>
        <div className="column is-half">
          <div className="control">
            <input
              className="input is-size-7 is-radiusless is-fullwidth"
              type="text"
              placeholder="Postcode"
              value={addressResidential.postcode}
              onChange={(e) =>
                setAddressResidential({
                  ...addressResidential,
                  postcode: e.target.value,
                })
              }
            />
          </div>
        </div>
      </div>
      <div className="columns is-mobile is-variable is-1 is-vcentered">
        <div className="column is-8">
          <p className="menu-label">Postal Address</p>
        </div>
        <div className="column is-4 has-text-right">
          <label className="checkbox is-size-7">
            <input
              name="addressAsAbove"
              type="checkbox"
              className="is-radiusless"
              checked={postalSameAsResidential}
              onChange={(e) => {
                if (!postalSameAsResidential) {
                  setAddressPostal({ ...addressResidential });
                }
                setPostalSameAsResidential(!postalSameAsResidential);
              }}
            />{" "}
            as above
          </label>
        </div>
      </div>
      <div className="columns is-mobile is-variable is-1">
        <div className="column is-two-thirds">
          <div className="control">
            <input
              className="input is-size-7 is-radiusless is-fullwidth"
              type="text"
              placeholder="Address"
              value={addressPostal.streetAddress}
              onChange={(e) =>
                setAddressPostal({
                  ...addressPostal,
                  streetAddress: e.target.value,
                })
              }
            />
          </div>
        </div>
        <div className="column is-one-third">
          <div className="control">
            <div className="select is-size-7 is-fullwidth">
              <select
                className="is-radiusless"
                value={addressPostal.state}
                onChange={(e) => setAddressPostal({ ...addressPostal, state: e.target.value })}
              >
                <option value="">State</option>
                {auStates.map((state, idx) => (
                  <option key={idx} value={state.value}>
                    {state.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>
      <div className="columns is-mobile is-variable is-1">
        <div className="column is-half">
          <div className="control">
            <input
              className="input is-size-7 is-radiusless"
              type="text"
              placeholder="Suburb"
              value={addressPostal.suburb}
              onChange={(e) => setAddressPostal({ ...addressPostal, suburb: e.target.value })}
            />
          </div>
        </div>
        <div className="column is-half">
          <div className="control">
            <input
              className="input is-size-7 is-radiusless"
              type="text"
              placeholder="Postcode"
              value={addressPostal.postcode}
              onChange={(e) => setAddressPostal({ ...addressPostal, postcode: e.target.value })}
            />
          </div>
        </div>
      </div>
      <p className="menu-label">Contact Number</p>
      <div className="columns is-mobile is-variable is-1">
        <div className="column is-half">
          <div className="control">
            <input
              className="input is-size-7 is-radiusless"
              type="text"
              placeholder="Mobile e.g 0411754287"
              value={phoneNumberMobile}
              onChange={(e) => setPhoneNumberMobile(e.target.value)}
            />
          </div>
        </div>
        <div className="column is-half">
          <div className="control">
            <input
              className="input is-size-7 is-radiusless"
              type="text"
              placeholder="Home"
              value={phoneNumberHome}
              onChange={(e) => setPhoneNumberHome(e.target.value)}
            />
          </div>
        </div>
      </div>
      <div className="columns is-mobile is-variable is-1">
        <div className="column is-half">
          <div className="control">
            <input
              className="input is-size-7 is-radiusless"
              type="text"
              placeholder="Work"
              value={phoneNumberWork}
              onChange={(e) => setPhoneNumberWork(e.target.value)}
            />
          </div>
        </div>
        <div className="column is-half">
          <div className="control">
            <input
              className="input is-size-7 is-radiusless"
              type="text"
              placeholder="Fax"
              value={phoneNumberFax}
              onChange={(e) => setPhoneNumberFax(e.target.value)}
            />
          </div>
        </div>
      </div>
      {elementControl.isRenderClinic && (
        <ClinicForPatientForm
          clinic={clinic ?? {}}
          handleValueChange={handleClinicValueChange()}
          updateResource={updateClinicResource()}
        />
      )}
      {elementControl.isRenderReferrer && (
        <ReferrerForPatientForm
          referrer={referrer ?? {}}
          clinicId={clinic?.id}
          handleValueChange={handleReferrerValueChange()}
          updateResource={updateReferrerResource()}
        />
      )}
      {elementControl.isRenderReferralDate && (
        <div className="columns is-mobile is-variable is-1">
          <div className="column is-one-third">
            <p className="menu-label">Referral start date</p>
            <div className="control">
              <input
                disabled={elementControl?.isDisableReferralDate}
                className="input is-small is-radiusless"
                type="date"
                value={startDate}
                onChange={handleStartDateChange}
              />
            </div>
          </div>
          <div className="column is-one-third">
            <p className="menu-label">Referral expiry date</p>
            <div className="control">
              <input
                disabled={elementControl?.isDisableReferralDate}
                className="input is-small is-radiusless"
                type="date"
                value={expiredDate}
                onChange={handleExpiryDateChange}
              />
            </div>
          </div>
          <div className="column is-one-third">
            <p className="menu-label">Expiry Date By Month</p>
            <div className="control">
              <div className="select is-size-7 is-fullwidth">
                <select
                  className="is-radiusless"
                  value={expiredDateByMonth}
                  onChange={handleExpiryDateByMonthChange}
                  disabled={elementControl?.isDisableReferralDate}
                >
                  <option key="" value="" />
                  {EXPIRY_DATE_BY_MONTH?.map(({ label, value }) => (
                    <option key={label} value={value}>
                      {label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="columns">
        <div className="column">
          <div className="control">
            <Button text={actionName} isLoading={isLoading} onClick={handleSubmit} />
          </div>
        </div>
      </div>
    </>
  );
};

export default PatientForm;
